import { createContext, useMemo } from 'react';
import { workerErrorPropToError, } from '../../controller/workerErrorProp';
export var ErrorContext = createContext({
    error: null,
    errorId: null,
    errorEnvironment: null,
});
export var ErrorProvider = ErrorContext.Provider;
export var useWidgetErrorContext = function (widgetError, widgetErrorId, workerError) {
    return useMemo(function () {
        if (workerError) {
            var _a = workerErrorPropToError(workerError), error = _a.error, errorId = _a.errorId;
            return {
                error: error,
                errorId: errorId !== null && errorId !== void 0 ? errorId : null,
                errorEnvironment: 'controller',
            };
        }
        if (widgetError) {
            return {
                error: widgetError,
                errorId: widgetErrorId !== null && widgetErrorId !== void 0 ? widgetErrorId : null,
                errorEnvironment: 'component',
            };
        }
        return {
            error: null,
            errorId: null,
            errorEnvironment: null,
        };
    }, [widgetError, workerError]);
};
//# sourceMappingURL=ErrorProvider.js.map